import { render } from "./AposPermissionGrid.vue?vue&type=template&id=7ce47ee4&scoped=true"
import script from "./AposPermissionGrid.vue?vue&type=script&lang=js"
export * from "./AposPermissionGrid.vue?vue&type=script&lang=js"

import "./AposPermissionGrid.vue?vue&type=style&index=0&id=7ce47ee4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce47ee4"],['__file',"permission/ui/apos/components/AposPermissionGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ce47ee4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ce47ee4', __exports__)) {
    api.reload('7ce47ee4', __exports__)
  }
  
  module.hot.accept("./AposPermissionGrid.vue?vue&type=template&id=7ce47ee4&scoped=true", () => {
    api.rerender('7ce47ee4', render)
  })

}


export default __exports__